import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../core/authentication/auth.service';

@Injectable({
  providedIn: 'root'
})
export class LoginRedirectGuard implements CanActivate {
  private static readonly VERIFICATION_CODE = '6e9dd38c-1a52-4c0f-9089-59ef4c16bb70';

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const verificationCode = route.queryParams && route.queryParams.verificationcode;
    const isVerificationFlow = verificationCode === LoginRedirectGuard.VERIFICATION_CODE;

    if (isVerificationFlow) {
      return true;
    }

    if (this.authService.isAuthenticated()) {
      this.router.navigate([''], { replaceUrl: true });
      return false;
    }

    return true;
  }
}
